/** Observers share the incumbent socket; graph traffic never opens another connection. */
class NodeServiceLifecycle {
  private readonly listeners = new Set<(connected: boolean) => void>();
  public subscribe(listener: (connected: boolean) => void): () => void { this.listeners.add(listener); return () => this.listeners.delete(listener); }
  public changed(connected: boolean): void { this.listeners.forEach(listener => listener(connected)); }
}
export const nodeServiceLifecycle = new NodeServiceLifecycle();
